// Top Ranker 통계(top-ranker-stats)의 지표 계산식. Top Ranker 페이지와 화면 도우미(PiP)가 같은 식을 쓴다.

// 화면 도우미(PiP)는 파워 커브(14일 윈도우)와 기간을 맞춰 14일을 쓴다. Top Ranker 페이지는 자체 상태(기본 7일)를 쓴다.
export const DEFAULT_DAYS = 14;
export const DEFAULT_TIER = 'Diamond';
export const DEFAULT_MAIN_WEATHERS = ['흐림', '쾌청', '비', '모래바람'];
export const DEFAULT_SUB_WEATHERS = ['무풍', '안개', '강풍', '벼락'];

// 평균 대비 15%(기본) 넘게 좋으면 빨강+굵게, 나쁘면 초록. lowerIsBetter는 평균 등수처럼 낮을수록 좋은 지표용.
export const getOutlierStyle = (
  currentValue,
  average,
  lowerIsBetter = false,
  thresholdPercent = 0.15,
  goodColor = 'red',
  badColor = '#07ae04'
) => {
  const style = {};
  if (average === null || average === undefined || Number.isNaN(average) || average === 0 || Number.isNaN(currentValue)) {
    return style;
  }

  const lowerBound = average * (1 - thresholdPercent);
  const upperBound = average * (1 + thresholdPercent);

  if (lowerIsBetter) {
    if (currentValue < lowerBound) {
      style.color = goodColor;
      style.fontWeight = 'bold';
    } else if (currentValue > upperBound) {
      style.color = badColor;
    }
  } else if (currentValue > upperBound) {
    style.color = goodColor;
    style.fontWeight = 'bold';
  } else if (currentValue < lowerBound) {
    style.color = badColor;
  }
  return style;
};

export const totalGameCountOf = (stats) => stats.reduce((sum, stat) => sum + stat.gameCount, 0);

// 한 (캐릭터, 무기) 행의 지표. 픽률/승률/Top3율은 퍼센트(0~100)다.
export const computeMetrics = (stat, totalGameCount) => {
  const hasGames = stat.gameCount > 0;
  return {
    hasGames,
    pickRate: totalGameCount > 0 ? (stat.gameCount / totalGameCount) * 100 : 0,
    winRate: hasGames ? (stat.victory / stat.gameCount) * 100 : 0,
    top3Rate: hasGames ? (stat.top3 / stat.gameCount) * 100 : 0,
    rpGain: hasGames ? stat.mmrGain / stat.gameCount : null,
    avgRank: hasGames ? stat.gameRank / stat.gameCount : null,
    dmgPerGame: hasGames ? stat.damageToPlayer / stat.gameCount : 0,
    dps: stat.totalTime > 0 ? stat.damageToPlayer / stat.totalTime : 0,
    killsPerGame: hasGames ? stat.playerKill / stat.gameCount : 0,
    tkPerGame: hasGames ? stat.teamKill / stat.gameCount : 0,
  };
};

// 전체 평균(행별 지표의 단순 평균) — 평균 대비 강조(getOutlierStyle)의 기준값
export const computeAverages = (stats) => {
  const mean = (values) => (values.length ? values.reduce((sum, v) => sum + v, 0) / values.length : null);
  const played = (stats || []).filter((s) => s.gameCount > 0);
  return {
    avgRank: mean(played.map((s) => s.gameRank / s.gameCount)),
    avgWinRate: mean(played.map((s) => s.victory / s.gameCount)),
    avgTop3Rate: mean(played.map((s) => s.top3 / s.gameCount)),
    avgDamagePerGame: mean(played.map((s) => s.damageToPlayer / s.gameCount)),
    avgDps: mean(played.filter((s) => s.totalTime > 0).map((s) => s.damageToPlayer / s.totalTime)),
    avgKillsPerGame: mean(played.map((s) => s.playerKill / s.gameCount)),
    avgMmrGain: mean(played.map((s) => s.mmrGain / s.gameCount)),
  };
};
